import React, { useEffect, useMemo, useState } from "react";
import Filters from "./Filters";

type Values = Record<string, number[]>;

function useLockBody(lock: boolean) {
    useEffect(() => {
        if (!lock) return;
        const prev = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        return () => { document.body.style.overflow = prev; };
    }, [lock]);
}

export default function MobileFilters({
    filters,
    values,
    onApply,
    onClearAll,
    className = "",
    title = "Filters",
}: {
    filters: any;
    values: Values;
    onApply: (next: Values) => void;
    onClearAll?: () => void;
    className?: string;
    title?: string;
}) {
    const [open, setOpen] = useState(false);
    const [localValues, setLocalValues] = useState<Values>({});

    // открываем с актуальными значениями
    const openSheet = () => { setLocalValues(values || {}); setOpen(true); };
    const closeSheet = () => setOpen(false);

    useLockBody(open);

    const selectedCount = useMemo(() =>
        Object.values(localValues || {}).reduce((acc, arr) => acc + (arr?.length || 0), 0),
        [localValues]
    );

    // колбэк из внутреннего Filters (он отдаёт такой же shape)
    const handleInnerChange = (next: Values) => setLocalValues(next);

    const handleApply = () => { onApply(localValues); closeSheet(); };
    const handleClear = () => {
        setLocalValues({});
        onClearAll?.();
    };

    return (
        <>
            {/* Триггер-кнопка (видна только на мобилках) */}
            <button
                className={`md:hidden inline-flex items-center gap-2 rounded-lg border px-3 py-2 text-sm ${className}`}
                onClick={openSheet}
                aria-haspopup="dialog"
                aria-expanded={open}
            >
                <span>Filters</span>
                {selectedCount > 0 && (
                    <span className="rounded bg-blue-600 px-1.5 py-0.5 text-xs text-white">{selectedCount}</span>
                )}
            </button>

            {/* Оверлей */}
            {open && (
                <div
                    className="fixed inset-0 z-50"
                    role="dialog"
                    aria-modal="true"
                    onKeyDown={(e) => e.key === "Escape" && closeSheet()}
                >
                    <div className="absolute inset-0 bg-black/40" onClick={closeSheet} />

                    <div className="absolute inset-x-0 bottom-0 h-[80vh] max-h-[90vh] rounded-t-2xl bg-white shadow-lg flex flex-col">
                        {/* Header */}
                        <div className="flex items-center justify-between px-4 py-3 border-b">
                            <div className="font-medium">{title}</div>
                            {/* <button className="text-sm text-gray-600 hover:underline" onClick={handleClear}>
                                Clear all
                            </button> */}
                        </div>

                        {/* Body */}
                        <div className="min-h-0 flex-1 overflow-y-auto p-4">
                            <Filters filters={filters} values={localValues} onCallback={handleInnerChange} />
                        </div>

                        {/* Footer */}
                        <div className="border-t p-3">
                            <div className="flex gap-2">
                                <button
                                    onClick={closeSheet}
                                    className="flex-1 rounded-lg border px-4 py-2 text-sm"
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={handleApply}
                                    className="flex-1 rounded-lg bg-blue-600 px-4 py-2 text-sm text-white"
                                >
                                    Apply{selectedCount > 0 ? ` (${selectedCount})` : ""}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}